import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers/persistedReducer';
import Link from 'redux-first-router-link';

import styles from '../controllers/AuthController.module.scss';
import { ROUTE_ACTIONS } from '../store/routes';

export function Primary() {
  const props = useSelector((state: RootState) => { return {
    authLoading: state.user.authStatus.loading,
    errorMessage: state.user.authStatus.userMessage,
    payloadMessage: state.location.payload?.message
  }});

  return (
    <div className={styles.primaryNav}>
      {props.errorMessage ? <div className={styles.error}>{props.errorMessage}</div> : ''}
      {props.payloadMessage ? <div className={styles.message}>{props.payloadMessage}</div> : ''}
      <Link className={styles.authLink} to={{type: ROUTE_ACTIONS.AUTH_GUEST}}>Enter</Link>
      <a className={styles.link} href={encodeURI("mailto:support@clusterx.com?&subject=Cluster support request&body=I need help with:\r\n")}>Help</a>
    </div>
  );
}

export function Secondary() {
  return (
    <div className={styles.secondaryNav}>
      <Link className={styles.authLinkSecondary} to={{type: ROUTE_ACTIONS.AUTH_RBN}}>Login with RBN</Link>
    </div>
  );
}

export default {
  Primary,
  Secondary
}